import React from 'react';
import PropTypes from 'prop-types';
import {includes} from "../../../utils/DBUtils";
import {connect} from 'react-redux';
import {getUserResourcePermissions} from "../../../pages/Profile/selectors";
import Checkbox from "../BasicFormFields/Checkbox";
import {AvailableSteps} from "../../../api/resources";

const PermissionStyleSteps = AvailableSteps.map((step) => step.toLowerCase());

const AvailableStepsCheckboxOptions = (props) => {
    const options = props.allowedSteps.map((step) => {
        return {
            key: step,
            value: step,
            textKey: `add_step.${step}`
        };
    });
    return (
        <Checkbox value={props.value}
                  label={props.label}
                  name='lang-radio'
                  options={options}
                  onValueChanged={props.onValueChanged}/>
    )
};

AvailableStepsCheckboxOptions.propTypes = {
    value: PropTypes.any,
    allowedSteps: PropTypes.arrayOf(PropTypes.string),
    label: PropTypes.node
};

AvailableStepsCheckboxOptions.defaultProps = {
    allowedSteps: []
};

const mapStateToProps = (state) => {
    const resourcePermissions = getUserResourcePermissions(state);
    let allowedSteps = resourcePermissions.filter((permission) => {
        const isStep = includes(PermissionStyleSteps, permission.name);
        const canCreate = includes(permission.resourceActions, "CREATE");
        return isStep && canCreate;
    }).map((permission) => permission.name);

    // Temporary workaround: If user has CustomJsonStep permissions, also allow Beaker2Step
    if (includes(allowedSteps, 'customjsonstep')) {
        allowedSteps.push('beaker2step');
    }

    let stepsList = AvailableSteps.filter((step) => includes(allowedSteps, step.toLowerCase()));
    return {
        allowedSteps: stepsList
    }
};

const ConnectedAvailableStepsCheckboxOptions = connect(mapStateToProps, null)(AvailableStepsCheckboxOptions);

export default ConnectedAvailableStepsCheckboxOptions;


// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/AvailableStepsCheckboxOptions.jsx